import AdminCMSList from "@/pages/admin/AdminCMSList";

export default function AdminCampaigns() {
  return (
    <AdminCMSList
      testIdPrefix="admin-campaigns" title="Campaign" subtitle="Seasonal Campaigns"
      listEndpoint="/admin/campaigns"
      createEndpoint="/admin/campaigns"
      updateEndpoint={(id) => `/admin/campaigns/${id}`}
      deleteEndpoint={(id) => `/admin/campaigns/${id}`}
      visibilityKey="is_active"
      blank={{
        name: "Summer Special", slug: "summer-special",
        headline: "", description: "", banner_url: "",
        start_date: "", end_date: "", product_ids: [], is_active: true,
      }}
      fields={[
        { key: "name", label: "Name", full: true },
        { key: "slug", label: "Slug (used in URL)" },
        { key: "headline", label: "Headline" },
        { key: "description", label: "Description", type: "textarea", full: true, rows: 3 },
        { key: "banner_url", label: "Banner image URL", full: true },
        { key: "start_date", label: "Start date (YYYY-MM-DD)" },
        { key: "end_date", label: "End date (YYYY-MM-DD)" },
        { key: "product_ids", label: "Linked Flavour/Product IDs (optional, comma-sep)", type: "tags", full: true },
        { key: "is_active", label: "Active (will still auto-hide after end date)", type: "checkbox", help: "Active" },
      ]}
      renderCard={(c) => (
        <>
          {c.banner_url
            ? <img src={c.banner_url} alt={c.name} className="w-full aspect-[16/9] object-cover" />
            : <div className="w-full aspect-[16/9] bg-brand-muted grid place-items-center text-brand-charcoal/40 font-display text-3xl">{c.name}</div>}
          <div className="p-5">
            <div className="text-[10px] uppercase tracking-[0.22em] text-brand-red">{c.start_date} → {c.end_date}</div>
            <div className="font-display text-xl mt-1.5 leading-tight">{c.name}</div>
            {c.headline && <p className="text-xs text-brand-charcoal/65 mt-1.5 line-clamp-2">{c.headline}</p>}
          </div>
        </>
      )}
    />
  );
}
